import Box from '@mui/joy/Box';

import { useParams } from 'react-router-dom';

import HubRepoList from '@/components/HubRepoList';

import { PageTitle } from '../../components/PageTitle';

const Repo = () => {
  const { owner } = useParams();
  return (
    <div className="px-8">
      <Box display="flex" alignItems={'center'} gap={2}>
        <PageTitle>{owner}</PageTitle>
      </Box>

      <div className="max-w-2xl">
        <HubRepoList tenantHandle={owner} />
      </div>
    </div>
  );
};

export default Repo;
